import React from 'react'
import Explore from '../../features/student/Explore'

const ExplorePage = () => {
  return <Explore/>
}

export default ExplorePage